import { fetch, Method, Server, CLIENT_ID } from 'core/api/fetch';
// import { parseLoginToObject, parseRegisterToObject } from 'core/api/parser/auth';
import { parseUserToModel } from '../parser/auth';

const AuthRoutes = {
    // login: '/auth/login',
    me: '/api/v1.1.0/user',
    // signUp: '/api/v1.0.0/user/create_user',
    // forgottenPassword: '/auth/password',
    // verifyPassword: (code) => `/auth/password/verify/${code}`,
    refresh: '/api/auth/refresh',
    logout: '/api/auth/logout',
};

export const AuthService = {
    // login: async ({ data }) => {
    //     try {
    //         return await fetch(AuthRoutes.login, {
    //             method: Method.POST,
    //             data: parseLoginToObject(data),
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },
    // logout: async ({ accessToken }) => {
    //     // no se utiliza el accessToken pues se extrae con la funcion fetch()
    //     try {
    //         const authMessage = await fetch(
    //             AuthRoutes.logout,
    //             {
    //                 authenticated: true,
    //                 method: Method.GET,
    //             }
    //             // accessToken
    //         );

    //         return authMessage;
    //     } catch (err) {
    //         return null;
    //     }
    // },
    me: async () => {
        const { data } = await fetch(AuthRoutes.me, {
            method: Method.GET,
            authenticated: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return parseUserToModel(data[0]);
    },
    // refreshToken: async () => {},
    // changePassword: async () => {},
    // signUp: async ({ data }) => {
    //     try {
    //         const { status } = await fetch(AuthRoutes.signUp, {
    //             method: Method.POST,
    //             data: parseRegisterToObject(data),
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });

    //         return status;
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },
    // forgetPassword: async (email) => {
    //     try {
    //         const data = await fetch(AuthRoutes.forgottenPassword, {
    //             method: Method.POST,
    //             data: {
    //                 email,
    //             },
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //         return data === 'Accepted';
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },
    // verifyPassword: async (code) => {
    //     try {
    //         console.log('VERIFYING PASSWORD');
    //         const data = await fetch(AuthRoutes.verifyPassword(code), {
    //             method: Method.GET,
    //         });
    //         return data === 'OK';
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },
    // resetPassword: async (code, password) => {
    //     try {
    //         const data = await fetch(AuthRoutes.forgottenPassword, {
    //             method: Method.PUT,
    //             data: {
    //                 code,
    //                 password,
    //             },
    //         });
    //         console.log(`responseee ${data}`);
    //         return data === 'OK';
    //     } catch (err) {
    //         throw new Error(err);
    //     }
    // },
    refresh: async () => {
        try {
            return await fetch(AuthRoutes.refresh, {
                method: Method.POST,
                server: Server.AUTH,
                // client_id tells the authserver which per-service cookie to read and mint against.
                data: { client_id: CLIENT_ID },
            });
        } catch (error) {
            throw error;
        }
    },
    // Goes to the AUTH server, which is the only service that ever sees the refresh cookie. It
    // revokes the session server-side and clears the cookie; Server.AUTH selects the client that
    // sends credentials, without which the httpOnly cookie never leaves the browser. client_id
    // scopes the logout to THIS client's cookie so the other product's session stays alive.
    logout: async () => {
        try {
            return await fetch(AuthRoutes.logout, {
                method: Method.POST,
                server: Server.AUTH,
                data: { client_id: CLIENT_ID },
            });
        } catch (error) {
            throw error;
        }
    },
};
